import routerOptions0 from "/home/runner/work/evaluation/evaluation/node_modules/.pnpm/nuxt@3.21.7_@parcel+watcher@2.5.6_@types+node@22.19.19_@vue+compiler-sfc@3.5.35_cac@6.7_12a9db74314e84023408f0ff055333ae/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}